import React, { useState } from 'react';
import { AnimateIn, SectionRow } from '../components/Layout';
import { aboutContent } from '../data/mock';

const AboutPage = () => {
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (title) => {
    setOpenAccordion(openAccordion === title ? null : title);
  };

  return (
    <div>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <div className="inner">
            <AnimateIn>
              <h1 className="hero-headline" style={{ marginBottom: '24px' }}>
                {aboutContent.heroTitle}
              </h1>
            </AnimateIn>
            <AnimateIn delay={100}>
              <p className="hero-desc" style={{ maxWidth: '540px' }}>
                {aboutContent.heroDesc}
              </p>
            </AnimateIn>
          </div>
        </div>
      </section>

      <SectionRow number="One" label="Philosophy" />

      {/* Philosophy */}
      <section className="sec-light sec-pad-lg">
        <div className="inner">
          <div className="grid-2">
            <div>
              <AnimateIn>
                <h2 className="heading-lg">Our Foundation</h2>
              </AnimateIn>
            </div>
            <div>
              {aboutContent.philosophy.map((para, i) => (
                <AnimateIn key={para} delay={i * 120}>
                  <p className="body-text" style={{ marginBottom: '24px' }}>
                    {para}
                  </p>
                </AnimateIn>
              ))}
            </div>
          </div>
        </div>
      </section>

      <SectionRow number="Two" label="Areas of Expertise" />

      {/* Expertise — Accordion */}
      <section className="sec-white sec-pad-lg">
        <div className="inner">
          <div className="grid-2">
            <div>
              <AnimateIn>
                <h2 className="heading-lg">What We Do</h2>
              </AnimateIn>
              <AnimateIn delay={100}>
                <p className="body-text" style={{ marginTop: '24px' }}>
                  Our research spans multiple disciplines, united by a commitment to making the deepest form of human intelligence computationally accessible.
                </p>
              </AnimateIn>
            </div>
            <div>
              <div className="accordion-list">
                {aboutContent.expertise.map((item) => (
                  <div key={item.title} className="accordion-item" onClick={() => toggleAccordion(item.title)}>
                    <div className="accordion-header">
                      <span>{item.title}</span>
                      <span className={`accordion-toggle ${openAccordion === item.title ? 'open' : ''}`}>+</span>
                    </div>
                    <div className={`accordion-body ${openAccordion === item.title ? 'open' : ''}`}>
                      <div className="accordion-body-inner">
                        {item.desc}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <SectionRow number="Three" label="Founder" />

      {/* Founder — Portrait Style */}
      <section className="sec-sage sec-pad-lg">
        <div className="inner">
          <div className="grid-2">
            <div>
              <AnimateIn>
                <div style={{
                  fontFamily: "'Gambarino', Georgia, serif",
                  fontSize: 'clamp(32px, 4vw, 64px)',
                  lineHeight: '1.1',
                  marginBottom: '16px'
                }}>
                  {aboutContent.founder.name}
                </div>
              </AnimateIn>
              <AnimateIn delay={100}>
                <div className="label-sm" style={{ fontSize: '14px', marginBottom: '32px' }}>
                  {aboutContent.founder.role}
                </div>
              </AnimateIn>
            </div>
            <div>
              <AnimateIn delay={200}>
                <p className="body-text">
                  {aboutContent.founder.bio}
                </p>
              </AnimateIn>
            </div>
          </div>
        </div>
      </section>

      <SectionRow number="Four" label="Values" />

      {/* Values */}
      <section className="sec-white sec-pad-lg">
        <div className="inner">
          <div className="grid-3">
            {aboutContent.values.map((value, i) => (
              <AnimateIn key={value.title} delay={i * 120}>
                <div>
                  <h3 className="heading-md">{value.title}</h3>
                  <p className="body-text">{value.desc}</p>
                </div>
              </AnimateIn>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
